import React, { memo } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import styled from 'styled-components';

const BackIcon = ({ width = 30, height = 30 }) => (
  <BackSvg width={width} height={height} viewBox="0 0 16 16">
    <path d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z" />
  </BackSvg>
);

BackIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

const BackSvg = styled.svg`
  fill: ${(props) => props.theme.main.iconDefault};
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

export default memo(BackIcon);
